import { CircularProgress, InputAdornment, TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { useEffect, useMemo, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import ContactListItem from './ContactListItem';
import * as Actions from './store/actions';

const ChatsSidebar = ({ isContactsLoading, setIsChatLoading, setIsContactsLoading }) => {
	const dispatch = useDispatch();
	const [firstLoad, setFirstLoad] = useState(true);
	const currentConversationStatus = useSelector(({ chatApp }) => chatApp.contacts);
	const conversations = useSelector(({ chatApp }) => chatApp.contacts.entities);
	const selectedContactId = useSelector(({ chatApp }) => chatApp.contacts.selectedContactId);
	const [searchText, setSearchText] = useState('');
	const [hasMore, setHasMore] = useState(false);

	const handleLoadMore = () => {
		dispatch(Actions.getContactsPage(currentConversationStatus.next_page_url));
	};

	useEffect(() => {
		if (currentConversationStatus.next_page_url) {
			setHasMore(true);
		} else {
			setHasMore(false);
		}
	}, [currentConversationStatus]);

	const selectedContact = conversations.find((_contact) => _contact.id === selectedContactId);

	function handleSearchText(event) {
		setSearchText(event.target.value);
	}

	useEffect(() => {
		if (selectedContactId) {
			dispatch(Actions.getChat(selectedContactId, setIsChatLoading, selectedContact?.student_id));
		}
	}, []);

	useEffect(() => {
		if (firstLoad && conversations.length) {
			setFirstLoad(false);
			return () => 0;
		}
		const timeout = setTimeout(() => {
			dispatch(Actions.getContacts(setIsContactsLoading, searchText));
		}, 700);

		return () => {
			clearTimeout(timeout);
		};
	}, [searchText]);

	const handleContactClick = (contactId) => {
		const selectedConversation = conversations.filter((contact) => contact.id === contactId)[0];
		dispatch(Actions.setselectedContactId(contactId));
		dispatch(Actions.getChat(contactId, setIsChatLoading, selectedConversation.student_id));
		const temp = conversations.map((conversation) => {
			if (conversation.id === selectedConversation.id) {
				conversation.messages_unread_count = 0;
			}
			return conversation;
		});
		dispatch(Actions.updateContacts(temp));
	};

	return (
		<div className="flex flex-col flex-auto" style={{ height: '70vh' }}>
			{useMemo(
				() => (
					<div className="p-16 pt-32">
						<TextField
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => {
												document.getElementById('search').focus();
											}}
										>
											<img alt="search-icon" height="80%" src="assets/images/search-icon.svg" width="80%" />
										</IconButton>
									</InputAdornment>
								),
							}}
							className="w-full"
							id="search"
							label="Search"
							onChange={handleSearchText}
							value={searchText}
						/>
					</div>
				),
				[searchText],
			)}
			{isContactsLoading ? (
				<div className="flex justify-center mt-20">
					<CircularProgress size={25} />
				</div>
			) : (
				<div className="w-full">
					<div
						className="flex flex-col shrink-0 overflow-auto"
						id="chat-sidebar-scrollable-div"
						style={{ height: '55vh' }}
					>
						<InfiniteScroll
							dataLength={conversations.length}
							hasMore={hasMore}
							loader={<div>Loading...</div>}
							next={handleLoadMore}
							scrollableTarget="chat-sidebar-scrollable-div"
						>
							{conversations.map((conversation) => (
								<ContactListItem
									conversation={conversation}
									key={conversation.id}
									onContactClick={handleContactClick}
								/>
							))}
						</InfiniteScroll>
					</div>
				</div>
			)}
		</div>
	);
};

export default ChatsSidebar;
